import { connect } from "react-redux";

import ListPharmacys from "./ListPharmacys";

const mapStatetoProps = state => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(
  mapStatetoProps,
  mapDispatchToProps
)(ListPharmacys);
